import { css, cx } from "@linaria/core"

import type { HTMLAttributes, RefAttributes } from "react"

type CardProps = HTMLAttributes<HTMLDivElement> & RefAttributes<HTMLDivElement>

const Card = ({ className, ref, ...props }: CardProps) => (
  <div
    ref={ref}
    className={cx(styles.Card, className)}
    {...props}
  />
)

type CardHeaderProps = HTMLAttributes<HTMLDivElement> & RefAttributes<HTMLDivElement>

const CardHeader = ({ ref, ...props }: CardHeaderProps) => (
  <div
    ref={ref}
    {...props}
  />
)

type CardTitleProps = HTMLAttributes<HTMLDivElement> & RefAttributes<HTMLDivElement>

const CardTitle = ({ ref, ...props }: CardTitleProps) => (
  <div
    ref={ref}
    {...props}
  />
)

type CardDescriptionProps = HTMLAttributes<HTMLDivElement> & RefAttributes<HTMLDivElement>

const CardDescription = ({ ref, ...props }: CardDescriptionProps) => (
  <div
    ref={ref}
    {...props}
  />
)

type CardContentProps = HTMLAttributes<HTMLDivElement> & RefAttributes<HTMLDivElement>

const CardContent = ({ ref, ...props }: CardContentProps) => (
  <div ref={ref}
       {...props}
  />
)

type CardFooterProps = HTMLAttributes<HTMLDivElement> & RefAttributes<HTMLDivElement>

const CardFooter = ({ ref, ...props }: CardFooterProps) => (
  <div
    ref={ref}
    {...props}
  />
)

const styles = {
  Card: css`
    padding: 8px;
    border-radius: var(--border-radius-8);
    background: var(--text-color-2);
  `
}

export { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle }
